import Affectation from "@/pages/administrer/configuration/type_affectation/Affectation.vue";
import CreateAffectation from "@/pages/administrer/configuration/type_affectation/CreateAffectation.vue";
import ShowAffectation from "@/pages/administrer/configuration/type_affectation/ShowAffectation.vue";

export default  [{
    path: 'affectations',
    meta: { permissions: ["view_affectation"] },
    name: "AdminConfigAffectation",
    component: Affectation
},
{
    path: 'affectations/create',
    meta: { permissions: ["create_affectation"] },
    name: "AdminConfigCreateAffectation",
    component: CreateAffectation
},
{
    path: 'affectations/:id/show',
    meta: { permissions: ["view_any_affectation"] },
    name: "AdminConfigShowAffectation",
    component: ShowAffectation
},]